import React, { useEffect, useState } from 'react';
import { Input, Textarea } from '../../components/forms/input';
import axios from 'axios';
import Thanks from '../../components/Thanks';

const Proposal = props => {
  const [showProposal, setShowProposal] = useState(props.show);
  const [formdata, setFormdata] = useState({});
  const [showThanks, setShowThanks] = useState(false);
  const [loadedThanks, setLoadedThanks] = useState(false);
  const [title, setTitle] = useState(props.title);
  const handleChange = (param, value) => {
    if (param == 'nda') {
      if (value) value = 'Yes';
      else value = 'No';
    }
    setFormdata(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  };
  const onSubmit = e => {
    e.preventDefault();
    var that = this;
    var form_data = new FormData(e.target);
    for (var key in formdata) {
      form_data.append(key, formdata[key]);
    }
    form_data.append('country', props.country);
    // props.hide();
    // setShowThanks(true)
    document.body.style.overflow = 'hidden';
    const email = formdata.email;
    axios.post('https://mailer.weprodigi.com/api/v1/video-production', form_data).then(response => {
      // e.target.reset()
      // setLoadedThanks(true)
      window.location.href = 'https://weprodigi.com/thank-you';
    });
  };
  const hideThanksModal = () => {
    setLoadedThanks(false);
    setShowThanks(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
  };
  const resetInputs = () => {
    document.getElementById('offer-form').reset();
    document.getElementById('name').value = '';
    document.getElementById('phone').value = '';
    document.getElementById('email').value = '';
    document.getElementById('website').value = '';
    document.getElementById('info').value = '';
    document.getElementById('nda').checked = false;
    setFormdata({});
  };
  useEffect(() => {
    setShowProposal(props.show);
    setTitle(props.title);
  }, [props.show, props.title]);
  return (
    <>
      <div
        className={
          'fixed z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center' +
          ' ' +
          (showProposal && !showThanks ? 'flex' : 'hidden')
        }
      >
        <div
          className="absolute left-0 top-0 w-full h-full"
          onClick={() => {
            props.hide();
            resetInputs();
          }}
        />
        <div className="relative w-11/12 max-w-screen-md md:max-w-600 bg-white border border-gray-transparent rounded-5">
          <div
            className="absolute -right-12 -top-12 bg-purple text-white w-30 h-30 text-21 rounded-full flex items-center justify-center cursor-pointer select-none"
            onClick={() => {
              props.hide();
              resetInputs();
            }}
          >
            <span className="font-bold">X</span>
          </div>
          <div className="p-23  ">
            <p className="text-purple uppercase text-30 text-center font-black leading-none">Get Proposal</p>
            <p className="text-black   text-18 text-center font-black mt-5 mb-15 leading-none capitalize  ">{title}</p>
            <form id="offer-form" method="POST" onSubmit={onSubmit}>
              <input type="hidden" name="service" value={title} />
              <input type="hidden" name="title" value={title} />
              <input type="hidden" name="budget" value={props.offerPrice || ''} />
              <div className="md:grid md:grid-cols-2 gap-x-23">
                <div>
                  <Input type="text" name="name" label={'Your name*'} bg="bg-gray-light" id="name" required={true} onChange={handleChange} />
                </div>
                <div>
                  <Input type="text" name="phone" label={'Phone Number'} bg="bg-gray-light" id="phone" required={false} onChange={handleChange} />
                </div>
                <div>
                  <Input type="text" name="email" bg="bg-gray-light" label={'Email*'} id="email" required={true} onChange={handleChange} />
                </div>
                <div>
                  <Input type="text" name="website" label={'Website'} bg="bg-gray-light" id="website" required={false} onChange={handleChange} />
                </div>
                <div className="col-span-2">
                  <Textarea
                    type="text"
                    placeholder=""
                    resize="resize-none"
                    label={'Additional information / Short description of the desired service'}
                    name="info"
                    bg="bg-gray-light"
                    id="info"
                    required={false}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group mr-30">
                <label className="relative pl-30 cursor-pointer text-purple text-14 flex items-center">
                  <input
                    id="nda"
                    className="absolute cursor-pointer opacity-0"
                    onChange={e => handleChange('nda', e.target.checked)}
                    type="checkbox"
                    name="nda"
                  />
                  <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                  Send NDA
                </label>
              </div>
              <input type="hidden" name="country" value={props.country} />

              <div className="col-span-2">
                <button
                  id="offer-submit"
                  type="submit"
                  className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Thanks show={showThanks} loaded={loadedThanks} hide={hideThanksModal}>
        <p>
          Something great is headed your way! <br />
          <br />
          Our sales specialist will get back to you as soon as possible. If you don’t receive an email from us within 24 hours please check your Spam
          Box.
        </p>
      </Thanks>
    </>
  );
};
export default Proposal;
